import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePutMyStore = (nameRef, addressRef, imgUrlRef) => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	const request = () => {
		if (!nameRef?.current?.value?.trim()) {
			setAlert('매장 이름을 입력해주세요.')
			return false
		}

		if (!addressRef?.current?.value?.trim()) {
			setAlert('매장 주소를 입력해주세요.')
			return false
		}

		fetchRequest('PUT', `/${rolePath}/store/my`, {
			store_name: nameRef?.current?.value?.trim(),
			address: addressRef?.current?.value?.trim(),
			logo_img: imgUrlRef?.current,
		})

		return true
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('매장 정보가 수정되었습니다.')
				break
			case 400:
				if (fetchResult?.data?.error_code === 'store_name')
					setAlert('매장 이름을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'address')
					setAlert('매장 주소를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 401:
				setAlert('권한이 없습니다.')
				break
			case 500:
				setAlert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
				break
			default:
				if (fetchResult?.statusCode) {
					setAlert('알 수 없는 오류가 발생했습니다.')
				}
				break
		}
	}, [fetchResult])

	return [request, fetchResult]
}

export default usePutMyStore
